// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"320605b2","268":"51517be6","484":"14cb0921","551":"c2ddb01f","828":"6cc522b3","851":"3f0086ba"}[chunkId] + ".chunk.js";
};